const Report = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.50464 8.23698C2.50464 8.08803 2.56553 7.94519 2.67393 7.83986C2.78232 7.73454 2.92934 7.67537 3.08263 7.67537H8.47723C8.63052 7.67537 8.77754 7.73454 8.88593 7.83986C8.99433 7.94519 9.05522 8.08803 9.05522 8.23698C9.05522 8.38593 8.99433 8.52878 8.88593 8.6341C8.77754 8.73943 8.63052 8.7986 8.47723 8.7986H3.08263C2.92934 8.7986 2.78232 8.73943 2.67393 8.6341C2.56553 8.52878 2.50464 8.38593 2.50464 8.23698ZM2.50464 10.4834C2.50464 10.3345 2.56553 10.1916 2.67393 10.0863C2.78232 9.98099 2.92934 9.92182 3.08263 9.92182H8.47723C8.63052 9.92182 8.77754 9.98099 8.88593 10.0863C8.99433 10.1916 9.05522 10.3345 9.05522 10.4834C9.05522 10.6324 8.99433 10.7752 8.88593 10.8806C8.77754 10.9859 8.63052 11.045 8.47723 11.045H3.08263C2.92934 11.045 2.78232 10.9859 2.67393 10.8806C2.56553 10.7752 2.50464 10.6324 2.50464 10.4834Z"
      fill="#546E7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.49763C0 0.672437 0.69205 0 1.54131 0H6.69701C7.13012 0 7.53857 0.178218 7.82602 0.472503L7.83065 0.477745L11.1537 3.99868C11.4304 4.28548 11.5599 4.66063 11.5599 5.01707V12.7299C11.5599 13.5551 10.8678 14.2275 10.0185 14.2275H1.54131C0.69205 14.2275 0 13.5551 0 12.7299V1.49763ZM6.69624 1.49763H1.54131V12.7299H10.0185V5.01108L6.7078 1.50288L6.70549 1.50213L6.69624 1.49763Z"
      fill="#546E7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.69701 0C6.9014 0 7.09738 0.078893 7.2419 0.219323C7.38643 0.359754 7.46762 0.550218 7.46762 0.748817V4.26825H10.7892C10.8904 4.26825 10.9906 4.28762 11.0841 4.32526C11.1776 4.36289 11.2625 4.41804 11.3341 4.48758C11.4057 4.55711 11.4624 4.63966 11.5012 4.73051C11.5399 4.82136 11.5599 4.91874 11.5599 5.01707C11.5599 5.11541 11.5399 5.21278 11.5012 5.30363C11.4624 5.39448 11.4057 5.47703 11.3341 5.54657C11.2625 5.6161 11.1776 5.67126 11.0841 5.70889C10.9906 5.74652 10.8904 5.76589 10.7892 5.76589H6.69697C6.49257 5.76589 6.29656 5.687 6.15203 5.54657C6.0075 5.40613 5.92631 5.21567 5.92631 5.01707V0.748817C5.92631 0.550218 6.0075 0.359754 6.15203 0.219323C6.29656 0.078893 6.49262 0 6.69701 0Z"
      fill="#546E7A"
    />
  </svg>
);

export default Report;
